$(document).ready(function () {
  "use strict";
  // navbar js start ---
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar").addClass("nav-fixed");
    } else {
      $(".navbar").removeClass("nav-fixed");
    }
  });

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".sidebar-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".sidebar-wrapper-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".sidebar-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".sidebar-wrapper-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  // **..mobile-dropdown-accordion js start..**
  $(".sidebar-dropdown-sub-menu").slideUp();
  $(".sidebar-dropdown-btn").on("click", function () {
    $(this).next(".sidebar-dropdown-sub-menu").slideToggle();
    $(this).toggleClass("active");
  });

  $(".sidebar-submenu-open").on("click", function () {
    $(this).next(".megamenu-wrapper").addClass("active");
  });

  $(".sidebar-close-btn").on("click", function () {
    $(this).parent().parent().parent(".megamenu-wrapper").removeClass("active");
  });
  // **..mobile-dropdown-accordion js end..**

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(".search-bar-window-close-btn").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".search-bar-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(this).toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(".search-bar-window-close-btn").toggleClass("active");
    $("body").toggleClass("active");
  });

  // navbar js end ---

  // cart-sidebar js start---
  $(".cart-sidebar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".cart-sidebar").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".cart-sidebar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".cart-sidebar").removeClass("active");
    $("body").toggleClass("active");
  });

  $(document).on("click", ".side-cart-close-btn", function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(".cart-sidebar").toggleClass("active");
    $("body").toggleClass("active");
  });

  // cart-sidebar js end---

  // filter sidebar js start--
  $(".filter-open-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").addClass("active");
    $("body").toggleClass("active");
  });

  $(".filter-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").toggleClass("active");
  });

  $(".filter-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").toggleClass("active");
  });
  // filter sidebar js end--

  // **..filter-accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  });
  // **..filter-accordion js end..**

  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**

  // **..product-quantity js start..**

  $(".quantity-increase").click(function() {
        let $input = $(this).siblings(".quantity-total");
        let currentValue = parseInt($input.val()) || 0;
        $input.val(currentValue + 1).trigger("change");
  });

  $(".quantity-decrease").click(function() {
      let $input = $(this).siblings(".quantity-total");
      let currentValue = parseInt($input.val()) || 0;
      if (currentValue > 1) { // Prevent going below 1
          $input.val(currentValue - 1).trigger("change");
      }
  });
  // **..product-quantity js end..**


  // **..faq-accordion js start..**
  $(".faq-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..faq-accordion js end..**

  // --tab js start--
  $(".tab-nav-item:first-child").addClass("active");
  $(".desktop-tab-content-item").hide();
  $(".desktop-tab-content-item:first").show();

  $(".desktop-tabs-nav-item-link").click(function () {
    $(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".desktop-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --tab js end--


  // product-sidebar js start ---
	$(".product-sidebar-btn").click(function (event) {
		event.stopPropagation();
		$(this).next().toggleClass("active");
		$(this).next().find(".product-sidebar").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".product-sidebar-window-btn").click(function (event) {
		event.stopPropagation();
		$(this).parent().toggleClass("active");
		$(this).next().toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".product-sidebar-close-btn").click(function (event) {
		event.stopPropagation();
		$(this).parent().parent().parent().removeClass("active");
		$(this).parent().parent().removeClass("active");
		$("body").removeClass("active");
	});

  
	$(".variant_select").click(function (event) {
		event.stopPropagation();
		
		$(this).next().toggleClass("show");
	});

	$(".card-variant-close").click(function (event) {
		event.stopPropagation();
		$(this).parent().removeClass("show");
	});
	// product-sidebar js end ---

  // Add to Cart - product card
  $(document).on("click", ".addToCart", function (e) {
    e.preventDefault();
      const loader = this.querySelector(".loader");
  if (loader) loader.style.display = "block";

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      // data:$('#product_form').serialize(),
      data: $(this).parents("#product_form").serialize(),
      dataType: "json",
      success: function (data) {
        $(".cart-sidebar").toggleClass("active");
        $("body").toggleClass("active");
        cart_drawer_update();
        if (loader) loader.style.display = "none";
      },
      error: function (err) {
        console.log("Error", err);
      },
    });
  });


});



$(document).on("click", ".addToCartBtn", function (e) {
  e.preventDefault();
  const $form = $(this).closest("form.product_form");
  const loader = this.querySelector(".loader");
  if (loader) loader.style.display = "block";

  if (!$form.length) {
    console.error("Form not found!");
    return;
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: $form.serialize(),
    credentials: "same-origin",
  })
  .then(res => res.json())
  .then(() => {
    $(".cart-sidebar").addClass("active");
    $("body").addClass("active");
    if (loader) loader.style.display = "none";
    if (typeof cart_drawer_update === "function") cart_drawer_update();
  })
  .catch(err => {
    if (loader) loader.style.display = "none";
    console.error("Add to cart error", err);
  });
});



// btn js ---
// primary btn---
// $(function () {
//   $(".primary-btn")
//     .on("mouseenter", function (e) {
//       var parentOffset = $(this).offset(),
//         relX = e.pageX - parentOffset.left,
//         relY = e.pageY - parentOffset.top;
//       $(this).find("span").css({
//         top: relY,
//         left: relX,
//       });
//     })
//     .on("mouseout", function (e) {
//       var parentOffset = $(this).offset(),
//         relX = e.pageX - parentOffset.left,
//         relY = e.pageY - parentOffset.top;
//       $(this).find("span").css({
//         top: relY,
//         left: relX,
//       });
//     });
// });

// secondary btn--
// $(function () {
//   $(".secondary-btn")
//     .on("mouseenter", function (e) {
//       var parentOffset = $(this).offset(),
//         relX = e.pageX - parentOffset.left,
//         relY = e.pageY - parentOffset.top;
//       $(this).find("span").css({
//         top: relY,
//         left: relX,
//       });
//     })
//     .on("mouseout", function (e) {
//       var parentOffset = $(this).offset(),
//         relX = e.pageX - parentOffset.left,
//         relY = e.pageY - parentOffset.top;
//       $(this).find("span").css({
//         top: relY,
//         left: relX,
//       });
//     });
// });
// btn js ---

// topbar slider js start--
var swiper = new Swiper(".top-bar-slider", {
  slidesPerView: 1,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// topbar slider js end--

// banner slider js start--
let sliderAutoplay = $(".banner-slider").data("slider-autoplay");
let sliderDuration = $(".banner-slider").data("slider-duration") * 1000;
let sliderDots = $(".banner-slider").data("slider-dots");

let swiperOptions = {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
};

if (sliderAutoplay) {
  swiperOptions.autoplay = {
    delay: sliderDuration || 3000, // fallback to 3000ms if not set
    disableOnInteraction: false,
  };
}

var swiper = new Swiper(".banner-slider", swiperOptions);

// Hero slider (Mobile) js start--

var swiper = new Swiper(".hero-mobile-slider", {
  slidesPerView: 4.5,
  spaceBetween: 10,
  loop: true,
  speed: 4000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  // allowTouchMove: false,
  loopedSlides: 20,
  freeMode: true,
  freeModeMomentum: false,
});

// Hero slider (Mobile) js start--

// search-sidebar slider js start--
var swiper = new Swiper(".search-sidebar-slider", {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
// search-sidebar slider js end--

// categoryg-slider js start--

var swiper = new Swiper(".category-slide2", {
  slidesPerView: 5.7,
  spaceBetween: 40,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      spaceBetween: 16,
      slidesPerView: 4.5,
    },
    // when window width is >= 576px
    576: {
      spaceBetween: 20,
      slidesPerView: 4.5,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 30,
      slidesPerView: 4.5,
    },
    // when window width is >= 993px
    993: {
      spaceBetween: 40,
      slidesPerView: 6.7,
    },
  },
});

// category-sliderr js end--

// categoryg-slider js start--
var swiper = new Swiper(".category-slide", {
  slidesPerView: 5.7,
  spaceBetween: 40,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      spaceBetween: 20,
      slidesPerView: 2.5,
    },
    // when window width is >= 576px
    576: {
      spaceBetween: 20,
      slidesPerView: 3.9,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 30,
      slidesPerView: 4.3,
    },
    // when window width is >= 993px
    993: {
      spaceBetween: 40,
      slidesPerView: 5.7,
    },
  },
});
// category-sliderr js end--

// card-img-slider js start--
var swiper = new Swiper(".card-img-slide", {
  slidesPerView: 4,
  spaceBetween: 20,
  // grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.5,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 1.5,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 2.4,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// card-img-slider js end--

// search-page-product-slider js start--
var swiper = new Swiper(".search-page-product-slider", {
  slidesPerView: 4,
  grid: {
    rows: 2,
  },
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 2.5,
      grid: {
        rows: 1,
      },
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.5,
      grid: {
        rows: 1,
      },
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.4,
      grid: {
        rows: 1,
      },
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
      grid: {
        rows: 2,
      },
    },
  },
});
// search-page-product-slider js end--


// product-slider js start---
var swiper = new Swiper(".product-slider-thumb2", {
	direction: 'vertical',
	loop: true,
	spaceBetween: 20,
	slidesPerView: 5.5,
	freeMode: true,
	mousewheel: true,
	breakpoints: {
		// when window width is >= 1px
		1: {
			direction: 'horizontal',
			spaceBetween: 10,
			slidesPerView: 4.4,
		},
		// when window width is >= 576px
		576: {
			direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 5.3,
		},
		// when window width is >= 768px
		768: {
			direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 5.5,
		},
		// when window width is >= 993px
		993: {
			direction: 'vertical',
			spaceBetween: 20,
			slidesPerView: 5.5,
		}
	}
});
var swiper2 = new Swiper(".product-slider2", {
	loop: true,
	autoHeight: true,
	spaceBetween: 10,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	thumbs: {
		swiper: swiper,
	},
});
// product-slider js end---


// side-cart-slider js start--
var swiper = new Swiper(".side-cart-slider", {
  slidesPerView: 2.2,
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
// side-cart-slider js end--

// progesss-bar js start--
// const progress = document.querySelector(".progress");
// progress.addEventListener("input", function () {
//   const value = this.value;
//   this.style.background = `linear-gradient(to right,rgb(36, 40, 51) 0%,rgb(36, 40, 51) ${value}%,rgb(216, 216, 216) ${value}%)`;
// });
// progesss-bar js end--
// search page modal js start---
var body = document.querySelector("body");
var modal = document.querySelector(".search-page-wrapper-main");
var modal_open_btn = document.querySelector(".search-page-open-btn");
var mobile_modal_open_btn = document.querySelector(
  ".mobile-search-page-open-btn"
);
var modal_closeButton = document.querySelector(".search-page-close-btn");

function openModal() {
  if (modal) {
    modal.classList.add("show-modal");
    body.classList.add("active");
  }
}

function closeModal() {
  if (modal) {
    modal.classList.remove("show-modal");
    body.classList.remove("active");
  }
}

function windowOnClick(event) {
  if (event.target === modal) {
    closeModal();
  }
}

// check element exists
if (modal_open_btn) {
  modal_open_btn.addEventListener("click", openModal);
}

if (mobile_modal_open_btn) {
  mobile_modal_open_btn.addEventListener("click", openModal);
}

if (modal_closeButton) {
  modal_closeButton.addEventListener("click", closeModal);
}

window.addEventListener("click", windowOnClick);
// search page modal js end---

// ---------------- Cart Drawer JS Start ---------------- //
// cart item increase
function itemPlus(e, el) {
  var id = $(el).data("id");
  var $input = $(el).prev();
  var qty = parseInt($input.val()) + 1;

  // update immediately
  $input.val(qty);
  var currentCount = parseInt($(".side-cart-item-number").text()) || 0;
  $(".side-cart-item-number").text(currentCount + 1);
  $(".cart-item-count").text(currentCount + 1);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: { id: parseFloat(id), quantity: qty },
    dataType: "json",
    success: function () {
      cart_drawer_update();
    },
    error: function () {
      // revert on failure
      $input.val(qty - 1);
      $(".side-cart-item-number").text(currentCount);
      $(".cart-item-count").text(currentCount);
      console.log("Error updating quantity");
    },
  });
}
// cart item decrease
function itemMinus(e, el) {
  var id = $(el).data("id");
  var $input = $(el).next();
  var qty = parseInt($input.val()) - 1;

  // update immediately
  $input.val(qty < 1 ? 0 : qty);
  var currentCount = parseInt($(".side-cart-item-number").text()) || 0;
  var newCount = Math.max(0, currentCount - 1);
  $(".side-cart-item-number").text(newCount);
  $(".cart-item-count").text(newCount);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: { id: parseFloat(id), quantity: qty },
    dataType: "json",
    success: function () {
      cart_drawer_update();
    },
    error: function () {
      // revert on failure
      $input.val(qty + 1);
      $(".side-cart-item-number").text(currentCount);
      $(".cart-item-count").text(currentCount);
      console.log("Error updating quantity");
    },
  });
}
// cart item Remove
function itemRemoved(e, el) {
  var id = $(el).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

function cart_drawer_update() {
  fetch("/?section_id=cart-drawer")
    .then((reponse) => reponse.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_items = $(".cart-sidebar-box", cart_html);
      var cart_footer = $(".side-cart-product-content-footer", cart_html);
      var cart_progress = $(".side-cart-progress-bar-area", cart_html);
      $(".cart-sidebar-box").replaceWith(cart_items);
      $(".side-cart-product-content-footer").replaceWith(cart_footer);
      $(".side-cart-progress-bar-area").replaceWith(cart_progress);
    });

  $.getJSON("/cart.js", function (cart) {
    var total_items = cart.item_count;
    $(".side-cart-item-number").text(cart.item_count);
    if (total_items > 0) {
      $(".cart-item-count").removeClass("d-none");
      $(".cart-item-count").text(total_items);
    } else {
      $(".cart-item-count").addClass("d-none");
    }
  });
}

// ---------------- Cart Drawer JS End ---------------- //

// ========================= cart Page JS Start ==================== //
// cart item increase
function cartItemPlus(e, el) {
  var id = $(el).data("id");
  var qty = $(el).prev().val();
  qty = parseInt(qty) + 1;
  console.log("qty " + qty);
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_page_update();
      $(el).prev().val(qty);
    },
    error: function (err) {
      console.log("Error");
    },
  });
}
// cart Page item decrease
function cartItemMinus(e, el) {
  var id = $(el).data("id");
  var qty = $(el).next().val();
  qty = parseInt(qty) - 1;
  if (qty >= 1) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: parseFloat(id),
        quantity: qty,
      },
      dataType: "json",
      success: function (data) {
        cart_page_update();
        $(el).next().val(qty);
      },
      error: function (err) {
        console.log("Error");
      },
    });
  }
}
// cart item removed
function cartItemRemoved(e, el) {
  var id = $(el).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      cart_page_update();
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

// cart item update
function cart_page_update() {
  fetch("/?section_id=cart-items")
    .then((reponse) => reponse.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_wrapper = $(".cart-section-inner", cart_html);
      // var cart_empty = $(".cart-empty", cart_html);
      // var cart_items = $(".cart-product-table", cart_html);
      // var cart_order_summary = $(".cart-order-summary", cart_html);

      $(".cart-section-inner").replaceWith(cart_wrapper);
      // $(".cart-empty").replaceWith(cart_empty);
      // $(".cart-product-table").replaceWith(cart_items);
      // $(".cart-order-summary").replaceWith(cart_order_summary);
    });

  $.getJSON("/cart.js", function (cart) {
    var total_items = cart.item_count;
    $(".side-cart-item-number").text(cart.item_count);
    if (total_items > 0) {
      $(".cart-item-count").removeClass("d-none");
      $(".cart-heading").removeClass("d-none");
      $(".cart-item-count").text(total_items);
    } else {
      $(".cart-item-count").addClass("d-none");
      $(".cart-heading").addClass("d-none");
    }
  });
}

// ========================= cart Page Js End ==================== //

//Change image when product option changes

$(document).ready(function () {
  
  $(document).on('click', '.comming_soon_btn', function(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // also block form submit manually
    const form = $(this).closest('form');
    if (form.length) {
      form.on('submit', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        return false;
      });
    }

    $('.simple-popup').addClass('active');

    return false;
  });

  $('.modal_close').on('click', function(e){
    e.preventDefault();
    $('.simple-popup').removeClass('active');
  })

  $(".option_input_variant").on("change", function () {
    let optionName = "";

    let parent  = $(this).closest('.card-variants');
    // Get selected option value
    parent.find("input:radio.option_input_variant:checked").each(function (e) {
      optionName += e !== 0 ? "-" : "";
      optionName += $(this).val();
    });

    parent.find(".productSelect option").each(function () {
     
      var txt = $.trim($(this).text());
      if (txt === optionName) {
        var img = $(this).data("img");
        var id = $(this).val();
        var price = $(this).data("price");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");
        parent.find(".productSelect").val(id);
        // $("#product_id").val(id);

        // Fix here - updated form product id here
        // parent.find('.product_id').val(id);

        console.log('id ' + id);
        console.log('available ' + available);

        if (available) {
          parent.find(".addToCart").removeClass("sold_out");
          parent.find(".card_atc_text").text("Sepete Ekle");
        } else {
          parent.find(".addToCart").addClass("sold_out");
          parent.find(".card_atc_text").text("Tükendi");
        }

        $(this).closest('.card-content').find('.product_id').val(id)

        // $.ajax({
        //   type: "POST",
        //   url: "/cart/add.js",
        //   data: { id: id, quantity: 1 },
        //   dataType: "json",
        //   success: function (data) {
        //     $(".cart-sidebar").toggleClass("active");
        //     $("body").toggleClass("active");
        //     cart_drawer_update();
        //   },
        //   error: function (err) {
        //     console.log("Error", err);
        //   },
        // });
      }
    });
  });

  // Add to Cart - product page
 document.addEventListener("click", function (e) {
  const button = e.target.closest(".add-to-cart");
  if (!button) return;

  e.preventDefault();

  // show loader inside clicked button
  const loader = button.querySelector(".loader");
  if (loader) loader.style.display = "block";

  const id = document.querySelector("#product_id")?.value;
  const qty =
    parseInt(document.querySelector(".quantity-total")?.value) || 1;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: id,
      quantity: qty
    })
  })
    .then((res) => res.json())
    .then(() => {
      document.querySelector(".cart-sidebar")?.classList.add("active");
      document.body.classList.add("active");

      // hide loader after success
      if (loader) loader.style.display = "none";

      cart_drawer_update();
    })
    .catch((err) => {
      console.log("Add to cart error", err);

      // hide loader on error too
      if (loader) loader.style.display = "none";
    });
});
});
